var bezierCurves = function(svg, points) {
    this.t = .5;
    this.delta = .01;
    this.bezier = {};
    this.points = points;
    this.svg = svg;
    this.orders = null
    this.stroke = null;
    this.catrouteID = null;
    this.vis = null;
    this.route = null;
    this.animate = true;
    this.timer = null;


    this.interpolate = function(d, p) {
        if (arguments.length < 2) p = this.t;

        var r = [];

        for (var i=1; i<d.length; i++) {
            var d0 = d[i-1], d1 = d[i];
            r.push({x: d0.x + (d1.x - d0.x) * p, y: d0.y + (d1.y - d0.y) * p});
        }

        return r;
    }

    this.getLevels = function(d, t_) {
        if (arguments.length < 2) t_ = this.t;

        var x = [this.points.slice(0, d)];

        for (var i=1; i<d; i++) {
            x.push(this.interpolate(x[x.length-1], t_));
        }

        return x;
    }

    this.getCurve = function(d) {
        var curve = this.bezier[d];

        if (!curve) {
            curve = this.bezier[d] = [];
            for (var t_=0; t_<=1; t_+= this.delta) {
                var x = this.getLevels(d, t_);
                curve.push(x[x.length-1][0]);
            }
        }

        // if(!this.animate) {
        //     this.t = 1;
        // }
        this.t = 1;

        return [curve.slice(0, this.t / this.delta + 1)];
    }



    this.colour = function(d, i) {
        this.stroke(-i);
        return d.length > 1 ? this.stroke(i) : "red";
    };


    this.x = function(d) { return d.x; }
    this.y = function(d) { return d.y; }
    this.catroutepositionID = function(d) { return d.catroutepositionID; }


    this.update = function()
    {
        var my = this,
            interpolation = this.route.select('g.control-tools').selectAll("g").data(function(d) {
                return my.getLevels(d, my.t);
            });

        interpolation.enter().append("g")
            .style("fill", function(d, i) { return my.colour(d, i) })
            .style("stroke", function(d, i) { return my.colour(d, i) });


        var path = interpolation.selectAll("path")
            .data(function(d) { return [d]; });
        path.enter().append("path")
            .attr("class", "line control-tools")
            .attr("d", function(d) { return my.line(d); });
        path.attr("d", function(d) { return my.line(d); });

        my.route.select('path.curve')
            .attr("d", function(){ return my.simpleLine() });


        my.route.selectAll("text.controltext")
            .attr("x", function(d) { return my.x(d) })
            .attr("y", function(d) { return my.y(d) })
    }


    this.init = function()
    {
        var my = this,
            routes,
            direction = my.points[0].direction,
            direction_color = direction == 0 ? graph.color_in : graph.color_out;

        $.each(this.points, function(index, obj){
            var newPoint = graph.coordsToPixel(obj.x, obj.y);

            my.points[index].x = newPoint.x;
            my.points[index].y = newPoint.y;
        });


        routes = this.svg.append('g')
            .attr('class', 'routes');

        this.stroke = d3.scale.category20b();
        this.route = routes
            .data([my.points.length])
            .append('g')
            .attr('class', 'route')
            .attr('data-catrouteid', my.catrouteID)
            .attr('transform', 'translate(' + graph.margin.left + ',' + graph.margin.top + ')')
        ;

        var controlToolsGroup = this.route.append('g')
            .attr('class', 'control-tools');

        controlToolsGroup.selectAll("circle.support")
            .data(this.points)
            .enter().append("circle")
            .attr("class", "support red")
            .attr("r", 4)
            .attr("cx", this.x)
            .attr("cy", this.y)
        ;

        controlToolsGroup.selectAll("circle.control")
            .data(this.points)
            .enter().append("circle")
            .attr("class", "control")
            .attr("r", 7)
            .attr("cx", this.x)
            .attr("cy", this.y)
            .attr("data-x", this.x)
            .attr("data-y", this.y)
            .attr("data-catrouteid", this.catrouteID)
            .attr("data-catroutepositionid", this.catroutepositionID)
            .call(d3.behavior.drag()
                .on("dragstart", function(d) {
                    this.__origin__ = [d.x, d.y];
                    d3.select(this).classed("drag", true);
                })
                .on("drag", function(d) {
                    d.x = Math.min(graph.width, Math.max(0, this.__origin__[0] += d3.event.dx));
                    d.y = Math.min(graph.height, Math.max(0, this.__origin__[1] += d3.event.dy));
                    my.bezier = {};
                    my.update();
                    my.route.selectAll("circle.support, circle.control")
                        .attr("cx", my.x)
                        .attr("cy", my.y);
                })
                .on("dragend", function(d) {
                    var position = $(this),
                        positionMM = graph.coordsToMM(d.x, d.y);
                    delete this.__origin__;
                    d3.select(this).classed("drag", false);


                    $.post('/cat/graph/modifyPosition', {catrouteposition_x: positionMM.x, catrouteposition_y: positionMM.y, catroutepositionID: position.data('catroutepositionid')});
                }))
            ;

        $('circle.control').on('click', function(e) {
            var point = $(this),
            form = $('#cat-graph-form'),
            offset = $('#drawing').offset();


            form.find('#x').val(e.pageX - offset.left);
            form.find('#y').val(e.pageY - offset.top);
            form.find('#catrouteID').val(point.data('catrouteid'));
            form.find('#catroutepositionID').val(point.data('catroutepositionid'));
        });


        controlToolsGroup.selectAll("text.controltext")
            .data(this.points)
            .enter().append("text")
            .attr("class", "controltext label")
            .attr("dx", "10px")
            .attr("dy", ".4em")
            .text(function(d, i) { return "P" + i });


        this.route
            .append("path")
            .attr('marker-end', 'url(#arrow-transparent)')
            .attr('stroke', direction_color)
            .attr("class", "curve");

        this.update();
    }


    this.line = function(d) {
        var result = d3.svg.line().x(this.x).y(this.y);
        return result(d);
    }

    this.simpleLine = function() {
        var length = this.points.length,
            d = '';

        for(var i=0; i<length; i++) {
            var point = this.points[i];

            if(i == 0) {
                d = 'M' + point.x + ',' + point.y + ' C';
            } else {
                d += point.x + ',' + point.y + ' ';
            }
        }

        return d;
    }


    this.stopAnimation = function() {
        // this.animate = false;
        this.timer.stop();
        this.timer.timerFlush();
    }
};

